/**
 * 定义生成模块
 * 处理 TypeScript 类型定义的生成
 */
import { Paths, MethodsType } from '@/define';
import { Helper } from '@/methods/base';
import {
  handleRenderApiTsFileFeature,
  wrapperPreFixDefineName,
} from '@/methods/generator-interface';
import { generateHelpers, forEachPath } from '@/core/path-processor';

/**
 * 生成路径定义对象
 * @param paths - Swagger paths 对象
 * @returns 定义对象
 */
export const generatePathsDefine = (paths: Paths): any => {
  return handleRenderApiTsFileFeature(generateHelpers(paths));
};

/**
 * 生成路径定义名称列表
 * @param paths - Swagger paths 对象
 * @returns 定义名称数组
 */
export const generatePathsDefineNames = (paths: Paths): string[] => {
  const helpers: Helper[] = [];
  forEachPath(paths, ({ uri, method, schema }) => {
    helpers.push(new Helper(uri, method as MethodsType, schema));
  });
  return wrapperPreFixDefineName(helpers);
};

